module.exports = __webpack_public_path__ + "img/sheriffs.b2a1d226.gif";